import { INFLOW, OUTFLOW } from "@/cockpit/formatCockpit";

export function HatchDefs() {
  return (
    <defs>
      <pattern id="cockpit-inflow-hatch" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <rect width="7" height="7" fill={INFLOW} />
        <line x1="0" y1="0" x2="0" y2="7" stroke="#052e16" strokeWidth="2" />
      </pattern>
      <pattern id="cockpit-outflow-hatch" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(-45)">
        <rect width="7" height="7" fill={OUTFLOW} />
        <line x1="0" y1="0" x2="0" y2="7" stroke="#450a0a" strokeWidth="2" />
      </pattern>
    </defs>
  );
}

export function TriangleMark({ cx, cy, size, fill, direction = "up" }) {
  if (cx == null || cy == null) return null;
  const s = Math.max(5, Math.sqrt(Number(size) || 64) / 2.2);
  const d = direction === "down"
    ? `M ${cx} ${cy + s} L ${cx + s * 0.95} ${cy - s} L ${cx - s * 0.95} ${cy - s} Z`
    : `M ${cx} ${cy - s} L ${cx + s * 0.95} ${cy + s} L ${cx - s * 0.95} ${cy + s} Z`;
  return <path d={d} fill={fill} stroke="var(--hoip-bg)" strokeWidth={0.7} />;
}

export function BuyMark(props) {
  return <TriangleMark {...props} direction="up" />;
}

export function SellMark(props) {
  return <TriangleMark {...props} direction="down" />;
}

export function PartyDot({ cx, cy, stroke, party }) {
  if (cx == null || cy == null) return null;
  if (party === "R") {
    const s = 3.5;
    return <rect x={cx - s} y={cy - s} width={s * 2} height={s * 2} fill={stroke} stroke="var(--hoip-bg)" strokeWidth={0.6} />;
  }
  return <circle cx={cx} cy={cy} r={3.2} fill={stroke} stroke="var(--hoip-bg)" strokeWidth={0.6} />;
}

export function DirectionLegend({ payload }) {
  if (!payload?.length) return null;
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 justify-center text-[10px] pt-1" style={{ color: "var(--hoip-text-tertiary)" }}>
      {payload.map((p) => (
        <span key={p.value} className="inline-flex items-center gap-1" style={{ color: p.color }}>
          <span aria-hidden="true">{p.icon || (String(p.value).toLowerCase().includes("inflow") || String(p.value).toLowerCase().includes("buy") || String(p.value).toLowerCase().includes("democrat") ? "▲" : "▼")}</span>
          {p.value}
        </span>
      ))}
    </div>
  );
}
